'use strict'

module.exports.parseLineFeeds = function (message) {
  const newline = String.fromCharCode(13, 10)
  let result = message
  do {
    /* eslint-disable no-var */
    var split = result.split('\\n')
    result = split.join(newline)
  } while (split.length > 1)

  return result
}
